/*
  環境変数定義
  © 2021 Digital Information Technologies Corporation. All Rights Reserved.
  @author Digital Information Technologies Corporation
  @module src/constants/sysconfig.ts
*/

/*
  環境変数定義
  共通の環境変数を定義する。
  @class src:constants:sysconfig
  @static
*/

import LocalSysconfig from "./sysconfig.local";
import RevSysconfig from "./sysconfig.rev";
import RealSysconfig from "./sysconfig.real";

const SAILS_LOCALS: any = (window as any).SAILS_LOCALS;
let targetConfig: any;
if (!SAILS_LOCALS._environment || SAILS_LOCALS._environment === "development") {
  // 環境指定無し又は開発モードならローカル用ファイルを読み込む
  targetConfig = LocalSysconfig;
} else if (SAILS_LOCALS._environment === "staging") {
  // STG
  targetConfig = RevSysconfig;
} else if (SAILS_LOCALS._environment === "production") {
  // 本番
  targetConfig = RealSysconfig;
}

const sysconfig = {
  // 環境固有専用のプロパティ
  // 共通
  common: {
    // 開発モード
    devmode: LocalSysconfig.common.devmode,
  },

  analysis: {
    endpointUrl: LocalSysconfig.analysis.endpointUrl,
    envPath: LocalSysconfig.analysis.envPath,
    oldAnalysisApiUse: LocalSysconfig.analysis.oldAnalysisApiUse,
  },

  logs: {
    endpointUrl: LocalSysconfig.logs.endpointUrl,
    envPath: LocalSysconfig.logs.envPath,
    displayLogCollectionUrl: LocalSysconfig.logs.endpointUrl,
    openKey: LocalSysconfig.logs.openKey,
  },

  googleAnalytics: {
    trackingId: targetConfig.googleAnalytics.trackingId,
  },
};

export default sysconfig;
